import { DealRequest } from '@/app/api/types';
import ChevronDownIcon from '@/app/assets/icons/chevron-down.svg?react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
} from '@mui/material';
import { FC } from 'react';
import { ChronologyFlow } from './chronology-flow';
import { useTranslation } from 'react-i18next';

interface ChronologyAccordionProps {
  row?: DealRequest;
}

export const ChronologyAccordion: FC<ChronologyAccordionProps> = ({ row }) => {
  const { t } = useTranslation();
  if (!row) return null;

  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        border: '1px solid #E7E7F1',
        borderRadius: '1.2rem !important',
        overflow: 'hidden',
        background: '#FFFFFF',
        '&::before': { display: 'none' },
      }}
    >
      <AccordionSummary
        expandIcon={<ChevronDownIcon />}
        sx={{
          background: '#F8F8F9',
          p: 2,
          '&.Mui-expanded': { borderBottom: '1px solid #E7E7F1' },
        }}
      >
        <Stack direction='row' gap={0.5}>
          <Typography
            sx={{ fontSize: '1.7rem', fontWeight: 600, color: '#0B1370' }}
          >
            {t('chronology.title')}
          </Typography>
          <Box component='span' sx={{ color: '#F34F4F' }}>
            *
          </Box>
        </Stack>
      </AccordionSummary>

      <AccordionDetails sx={{ background: '#FFFFFF', p: 2 }}>
        <ChronologyFlow row={row} direction='horizontal' />
      </AccordionDetails>
    </Accordion>
  );
};
